import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49422082"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page page-alerts-history page-table" }
const _hoisted_2 = { class: "print-title show-print text-center" }
const _hoisted_3 = { class: "selector" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "search-condition"
}
const _hoisted_6 = {
  key: 1,
  class: "page-table-body"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "履歴はありません", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "table-print-wrapper show-print hide-sp"
}
const _hoisted_10 = { class: "table-print" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "発生日時"),
  /*#__PURE__*/_createElementVNode("th", null, "内容"),
  /*#__PURE__*/_createElementVNode("th", null, "設定値／実測値"),
  /*#__PURE__*/_createElementVNode("th", null, "解除日時")
], -1))
const _hoisted_12 = { class: "status" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = {
  key: 3,
  class: "page-table-body hide-sp hide-print"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", { class: "table-head" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "発生日時"),
    /*#__PURE__*/_createElementVNode("td", { class: "content" }, "内容"),
    /*#__PURE__*/_createElementVNode("td", { class: "values" }, "設定値／実測値"),
    /*#__PURE__*/_createElementVNode("td", null, "解除日時")
  ])
], -1))
const _hoisted_17 = { class: "table-main" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "alert-type mr-2" }
const _hoisted_20 = { class: "status" }
const _hoisted_21 = { class: "values" }
const _hoisted_22 = { class: "text-left" }
const _hoisted_23 = { class: "text-left" }
const _hoisted_24 = {
  key: 4,
  class: "page-table-body hide-pc hide-print"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", { class: "table-head" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "発生日時"),
    /*#__PURE__*/_createElementVNode("td", null, "内容")
  ])
], -1))
const _hoisted_26 = { class: "table-main" }
const _hoisted_27 = { class: "rows" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, "設定値", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, "実測値", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, "解除日時", -1))
const _hoisted_32 = { class: "content" }
const _hoisted_33 = { class: "rows" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "alert-type mr-2" }
const _hoisted_36 = { class: "status" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chobo" }, null, -1))
const _hoisted_38 = { class: "row text-left" }
const _hoisted_39 = { class: "row text-left" }
const _hoisted_40 = { class: "row" }

import { ref, onMounted, onUnmounted, computed } from 'vue'
import moment from 'moment'
import $ from 'jquery'
import { camelCase } from 'lodash'
import ControllPanel from '@/components/common/ControllPanel.vue'
import StationSelector from '@/components/common/StationSelector.vue'
import SpAlertsLinks from '@/components/alerts/SpAlertsLinks.vue'
import ThresholdSearchForm from '@/components/alerts/ThresholdSearchForm.vue'
import AlertIcon from '@/components/icons/AlertIcon.vue'
import { HEADER_SIZE, HEADER_MARGIN, CONTROLLER_SIZE, TABLE_MARGIN } from '@/lib/constants'
import AlertHistory from '@/models/AlertHistory'
import { useAlertHistoryStore } from '@/stores/alertHistoryStore'
import { useGlobalStore } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { rangeToISO } from '@/lib/formatter'
import CsvDownloader, { CsvData } from '@/lib/CsvDownloader'

type SearchPayload = {
  stationId: string
  thType: string
  startDate: Date
  endDate: Date
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const alertHistoryStore = useAlertHistoryStore()
const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const TABLE_HEADER_SIZE = 43

const records = computed(() => {
  if (searched.value) {
    return alertHistoryStore.history.histories.filter(h => `${h.target}_${h.status}` === thType.value)
  }

  const station = globalStore.currentStation
  const ap = station?.ap

  return alertHistoryStore.history.histories.map(h => {
    if (ap) {
      return {
        ...h,
        ...{
          comparison: h.comparison + ap,
          record: h.record + ap,
        },
      }
    }

    return h
  })
})
const fetched = ref<boolean>(false)
const tableBodySize = ref<number>(0)
const thType = ref<string>('')
const targetDate = ref<Date>(new Date())
const startDate = ref<Date>(new Date())
const endDate = ref<Date>(new Date())
const showPopup = ref<boolean>(false)
const searched = ref<boolean>(false)

const searchConditionText = computed(() => {
  const startDateText = moment(startDate.value).format('YYYY年MM月DD日')
  const endDateText = moment(endDate.value).format('YYYY年MM月DD日')
  const stationName = globalStore.currentStation?.name

  return `${startDateText} ~ ${endDateText} ${stationName} ${thType.value}`
})

const printTitle = computed(() => {
  const station = globalStore.currentStation
  const dateStr = moment(targetDate.value as Date).format('YYYY-MM-DD')

  return searched.value ? '閾値超過履歴' : `閾値超過履歴 ${dateStr} ${station?.name}`
})

const isIchinomiya = computed(() => {
  return globalStore.isIchinomiya
})

const onClickSearchBtn = () => {
  showPopup.value = !showPopup.value
}

const formatDate = (date: string, format = 'YYYY/MM/DD HH:mm') => {
  if (!date) {
    return '発表中'
  }

  return moment(date).format(format)
}

const getTableBodySize = (h: number) => {
  let bufferSize = HEADER_SIZE + HEADER_MARGIN + CONTROLLER_SIZE + TABLE_MARGIN * 2 + TABLE_HEADER_SIZE

  return h - bufferSize
}

const tableBodyStyle = () => {
  if (!tableBodySize.value) {
    return {}
  }

  if (window.innerHeight < 600) {
    tableBodySize.value = getTableBodySize(600)
  }

  return {
    height: `${tableBodySize.value}px`,
  }
}

const handleResize = () => {
  const h = window.innerHeight

  tableBodySize.value = getTableBodySize(h)
}

const handleTouchRow = (e: Event) => {
  if (!e.target) {
    return
  }

  const $target = $(e.target)
  const $tr = $target.closest('tr')

  $tr.toggleClass('open')
}

const onChangeStation = () => {
  searched.value = false
  fetch('month')
}

const onChangeDate = (date: Date) => {
  searched.value = false
  fetch('month', date, date)
}

const fetch = (resolution: string, date = new Date(), dateTo?: Date) => {
  const startTime = moment(date).startOf(resolution).format('YYYY-MM-DD HH:mm:ss')
  const endTime = moment(dateTo).endOf(resolution).format('YYYY-MM-DD HH:mm:ss')
  const range = { startTime, endTime } as Range
  const station = globalStore.currentStation

  if (!station) {
    return
  }

  targetDate.value = date

  alertHistoryStore.fetch({ range: rangeToISO(range), stationId: station?.stationId })
}

const titleStyle = (record: AlertHistory) => {
  const status = record.status
  const notiInfo = initDataStore.initData.notificationInfo?.[camelCase(status)]

  if (notiInfo === undefined) {
    return {}
  }

  return {
    backgroundColor: notiInfo.bgcolor,
    color: notiInfo.color,
  }
}

const search = (payload: SearchPayload) => {
  showPopup.value = false
  searched.value = true
  thType.value = payload.thType
  startDate.value = payload.startDate
  endDate.value = payload.endDate

  fetch('day', payload.startDate, payload.endDate)
}

const print = () => window.print()

const downloadCsv = () => {
  const csvHeaders = ['発生日時', '内容', '設定値', '実測値', '解除日時'] as string[]
  const station = globalStore.currentStation
  const area = globalStore.currentArea
  const dateStr = moment(targetDate.value as Date).format('YYYY-MM')
  const fileName = `${dateStr}_threashold_${area?.name}_${station?.name}.csv`
  const csvData = [csvHeaders] as CsvData

  records.value.forEach(record => {
    const field = getFieldName(record.target)
    const row = [
      formatDate(record.startTime),
      `${record.title}`,
      `${field}: ${record.comparison.toFixed(1)}${unit(record)} 以上`,
      `${field}: ${record.record.toFixed(1)}${unit(record)}`,
      formatDate(record.endTime),
    ]
    csvData.push(row)
  })

  CsvDownloader.download(csvData, fileName)
}

const getFieldName = (target: string) => {
  const key = camelCase(target)

  return initDataStore.fieldListItem(key).name
}

const decimal = (record: AlertHistory) => {
  const target = camelCase(record.target)

  return initDataStore.fieldListItem(target).decimal
}

const unit = (record: AlertHistory) => {
  const target = camelCase(record.target)

  return initDataStore.fieldListItem(target).unit
}

onMounted(async () => {
  fetch('month')
  window.addEventListener('resize', handleResize)
  handleResize()
  fetched.value = true
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SpAlertsLinks),
    _createVNode(ThresholdSearchForm, {
      show: showPopup.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showPopup).value = $event)),
      onSearch: search
    }, null, 8, ["show"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(printTitle)), 1),
    _createVNode(ControllPanel, {
      onChangeDate: onChangeDate,
      "default-resolution": "month",
      "show-resolution": false,
      class: "flex-center hide-print bg-gray"
    }, {
      left: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(StationSelector, {
            onChange: onChangeStation,
            "station-type": "observable"
          })
        ])
      ]),
      center: _withCtx(() => [
        (!_unref(isIchinomiya))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: onClickSearchBtn,
                class: "btn btn-submit hide-sp"
              }, "検索")
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", { class: "actions hide-sp" }, [
          _createElementVNode("div", {
            onClick: downloadCsv,
            class: "actions-item with-icon btn-csv"
          }, "CSV"),
          _createElementVNode("div", {
            onClick: print,
            class: "actions-item with-icon btn-print"
          }, "印刷")
        ])
      ]),
      _: 1
    }),
    (searched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(searchConditionText)), 1))
      : _createCommentVNode("", true),
    (fetched.value && _unref(records).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    (fetched.value && _unref(records).length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(records), (record, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(formatDate(record.startTime)), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(record.title), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, " 設定値 " + _toDisplayString(getFieldName(record.target)) + ": " + _toDisplayString(record.comparison.toFixed(decimal(record))) + _toDisplayString(unit(record)) + " 以上 ", 1),
                  _createElementVNode("div", _hoisted_14, " 実測値 " + _toDisplayString(getFieldName(record.target)) + ": " + _toDisplayString(record.record.toFixed(decimal(record))) + _toDisplayString(unit(record)), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(formatDate(record.endTime)), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (fetched.value && _unref(records).length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          (_unref(records).length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle(tableBodyStyle()),
                class: "table-main-wrapper"
              }, [
                _createElementVNode("table", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(records), (record, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(formatDate(record.startTime)), 1),
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(AlertIcon, _normalizeProps(_guardReactiveProps(titleStyle(record))), null, 16)
                        ]),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(record.title), 1)
                      ]),
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, " 設定値 " + _toDisplayString(getFieldName(record.target)) + ": " + _toDisplayString(record.comparison.toFixed(decimal(record))) + _toDisplayString(unit(record)) + " 以上 ", 1),
                        _createElementVNode("div", _hoisted_23, " 実測値 " + _toDisplayString(getFieldName(record.target)) + ": " + _toDisplayString(record.record.toFixed(decimal(record))) + _toDisplayString(unit(record)), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(formatDate(record.endTime)), 1)
                    ]))
                  }), 128))
                ])
              ], 4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(records).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _hoisted_25,
          (_unref(records).length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: tableBodyStyle,
                class: "table-main-wrapper table-main-wrapper-sp"
              }, [
                _createElementVNode("table", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(records), (record, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      onClick: handleTouchRow,
                      key: index
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(formatDate(record.startTime, 'DD日 HH:mm')), 1),
                          _hoisted_29,
                          _hoisted_30,
                          _hoisted_31
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("span", _hoisted_35, [
                              _createVNode(AlertIcon, _normalizeProps(_guardReactiveProps(titleStyle(record))), null, 16)
                            ]),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(record.title), 1),
                            _hoisted_37
                          ]),
                          _createElementVNode("div", _hoisted_38, _toDisplayString(getFieldName(record.target)) + ": " + _toDisplayString(record.comparison.toFixed(decimal(record))) + _toDisplayString(unit(record)) + " 以上 ", 1),
                          _createElementVNode("div", _hoisted_39, _toDisplayString(getFieldName(record.target)) + ": " + _toDisplayString(record.record.toFixed(decimal(record))) + _toDisplayString(unit(record)), 1),
                          _createElementVNode("div", _hoisted_40, _toDisplayString(formatDate(record.endTime, 'DD日 HH:mm')), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})